module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/~/websocket/lib/version.js
// module id = 702
// module chunks = 0